const state = {
  persistance: {
    userName: ''
  }
}

const mutations = {
  SET_PERSISTANCE_NAME (state, payload) {
    state.persistance.userName = payload
  }
}

const getters = {
  GET_USERNAME (state) {
    return state.persistance.userName
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters
}
